import {IImage} from '@dazn/lp-web/src/types/common.types';

let contentfulImageLoadQuality: number | null = null;
const getContentfulImageLoadQuality = () => {
    try {
        if (contentfulImageLoadQuality !== null) {
            return contentfulImageLoadQuality;
        }
        contentfulImageLoadQuality = window.dazn.features.getVariableIntegerAnonymous(
            'f_ar_catalog_image_quality',
            'contentfulImageQuality'
        );
        return contentfulImageLoadQuality;
    } catch (e) {
        return 100;
    }
};

export function getImage(image: any): IImage {
    if (!image) {
        return {src: ''};
    }

    let quality = getContentfulImageLoadQuality();
    if (image?.fields?.file) {
        return {
            src: image.fields.file.url
                ? `https:${image.fields?.file?.url}?fm=webp&q=${quality}`
                : ''
        };
    }

    const getImageUrl = (img: any, type: string) => {
        if (!img?.fields?.[type]) {
            return '';
        }
        return `https:${img?.fields?.[type]?.fields?.file?.url}?fm=webp&q=${quality}`;
    };

    const imageSrcSet = {
        default: getImageUrl(image, 'default'),
        mobile: getImageUrl(image, 'mobile'),
        tablet: getImageUrl(image, 'tablet'),
        web: getImageUrl(image, 'web'),
        livingRoom: getImageUrl(image, 'livingRoom')
    };

    return {
        ...imageSrcSet,
        src: imageSrcSet?.default,
        srcSet: [
            imageSrcSet.mobile,
            imageSrcSet.tablet,
            imageSrcSet.web,
            imageSrcSet.livingRoom
        ]
    };
}
